import { actionCopyFr } from "./actionCopy";
import { listCopyFr } from "./listCopy";

export const profileCopyFr = {
    title: "Profil",
    description: "Gérez votre profil et vos paramètres",
    contactDetails: "Coordonnées",
    name: listCopyFr.name,
    titleLabel: "Civilité",
    selectPlaceholder: "Sélectionner",
    requiredField: "Obligatoire",
    firstNameRequired: "Le prénom est obligatoire",
    lastNameRequired: "Le nom est obligatoire",
    firstName: "Prénom",
    lastName: "Nom",
    noName: "Aucun nom",
    dateOfBirth: listCopyFr.dateOfBirth,
    dateOfBirthFormatDescription: "Veuillez utiliser le format JJ MM AAAA.",
    dobPlaceholderDay: "JJ",
    dobPlaceholderMonth: "MM",
    dobPlaceholderYear: "AAAA",
    dobDayRequired: "Le jour est obligatoire",
    dobMonthRequired: "Le mois est obligatoire",
    dobYearRequired: "L'année est obligatoire",
    dobMaxDaysInMonth: "Un mois compte au maximum 31 jours",
    dobMonthsInYear: "Une année ne compte que 12 mois",
    dobYearTooEarly: "Cette année est trop ancienne",
    dobYearInFuture: "C'est dans le futur !",
    noDateOfBirth: "Aucune date de naissance",
    email: listCopyFr.email,
    noEmail: "Aucune adresse e-mail",
    updateEmail: "Modifier l'adresse e-mail",
    validEmailAddress: "Veuillez saisir une adresse e-mail valide",
    accountSignInEmailRequired: "Saisissez l'adresse e-mail de connexion du compte que vous modifiez",
    newEmailDifferentFromSignIn:
        "La nouvelle adresse e-mail doit être différente de l'adresse e-mail de connexion que vous remplacez",
    newEmailDifferentFromCurrent: "La nouvelle adresse e-mail doit être différente de votre adresse actuelle",
    differentEmailAddress: "Saisissez une adresse e-mail différente",
    noSignInEmailToChange: "Aucune adresse e-mail de connexion à modifier",
    emailUpdatedSuccessfully: "Adresse e-mail mise à jour avec succès",
    emailUpdateFailed: "Échec de la mise à jour de l'adresse e-mail. Veuillez réessayer.",
    emailSavedToProfile: "Adresse e-mail enregistrée dans votre profil",
    emailSaveToProfileFailed: "Impossible d'enregistrer l'adresse e-mail dans votre profil. Veuillez réessayer.",
    loading: actionCopyFr.loading,
    profileEmailIntro: (email) => `L'adresse e-mail du profil est ${email}.`,
    profileEmailIntroSuffix: "Saisissez la nouvelle adresse ci-dessous.",
    signInEmailDiffersHelp:
        "Si l'adresse e-mail de connexion diffère de celle du profil (par exemple après un problème de synchronisation), utilisez le champ facultatif.",
    noProfileEmailReplaceDescription:
        "Aucune adresse e-mail sur ce profil. Saisissez l'adresse e-mail de connexion du compte à remplacer, puis la nouvelle adresse.",
    signInEmailOnlyIfDifferent: "Adresse e-mail de connexion (uniquement si différente de celle du profil)",
    signInEmail: "Adresse e-mail de connexion",
    leaveBlankIfSameAsProfile: "Laissez vide si identique à celle du profil",
    newEmail: "Nouvelle adresse e-mail",
    emailAddressToChangeTo: "Adresse e-mail à utiliser",
    accountSignInEmailIntro: (email) =>
        `L'adresse e-mail de connexion de votre compte est ${email}, mais elle n'apparaît pas encore dans votre profil. Vous pouvez l'enregistrer dans votre profil maintenant.`,
    saveEmailToProfile: "Enregistrer l'adresse e-mail dans le profil",
    saveEmailFirstDescription:
        "Une fois enregistrée, vous pourrez changer d'adresse depuis cette boîte de dialogue. Pour passer à une autre adresse avec un lien de confirmation au préalable, utilisez",
    noProfileEmailAddDescription:
        "Votre profil ne comporte pas encore d'adresse e-mail. Ajoutez-en une ci-dessous - par exemple si vous vous êtes inscrit(e) avec votre numéro de téléphone.",
    profileEmailLink: "Profil - E-mail",
    noEmailOnAccountPhoneSignup:
        "Aucune adresse e-mail sur ce compte pour le moment (par exemple si vous vous êtes inscrit(e) avec votre téléphone)",
    currentEmail: "Adresse e-mail actuelle",
    emailConfirmationSecurityDescription:
        "Nous vous enverrons un lien de confirmation par e-mail. Pour des raisons de sécurité, rien ne change tant que vous n'avez pas ouvert ce lien.",
    emailConfirmationSent:
        "Confirmation envoyée - consultez votre nouvelle boîte de réception pour trouver notre lien. Votre adresse e-mail de connexion ne changera pas tant que vous n'aurez pas confirmé.",
    emailChangeStartFailed: "Impossible de lancer le changement d'adresse e-mail. Veuillez réessayer.",
    sending: actionCopyFr.sending,
    sendConfirmationEmail: "Envoyer l'e-mail de confirmation",
    phone: "Téléphone",
    noPhoneNumber: "Aucun numéro de téléphone",
    notifications: "Notifications",
    notificationPreferences: "Préférences de notification",
    notificationPreferencesMissing: "Préférences de notification manquantes",
    notificationPreferencesNotSpecified: "Préférences de notification non précisées",
    notificationPreferencesDescription: "Choisissez comment vous souhaitez recevoir les notifications",
    notificationsEnabled: "Activées",
    notificationsDisabled: "Désactivées",
    notificationsDisabledWarningPatient:
        "Nous vous recommandons d'activer les notifications par e-mail ou par SMS afin de recevoir les rappels importants concernant vos saisies de journal et les messages.",
    notificationsDisabledWarningClinician:
        "Nous vous recommandons d'activer les notifications par e-mail ou par SMS afin de recevoir les résumés hebdomadaires de la progression de vos patients.",
    notificationPreferencesSaved: "Préférences de notification enregistrées",
    notificationPreferencesSaveFailed: "Échec de l'enregistrement des préférences",
    appearance: "Apparence",
    darkMode: "Mode sombre",
    darkModeDescription: "Utiliser un fond sombre dans l'application.",
    switchToDarkMode: "Passer en mode sombre",
    switchToLightMode: "Passer en mode clair",
    language: "Langue",
    languageDescription: "Choisissez la langue des menus, des boutons et des rappels.",
    chooseLanguage: "Choisir la langue",
    otherActions: "Autres actions",
    billingAndSubscription: "Facturation et abonnement",
    hospitalDetails: "Informations hospitalières",
    clinicianNumberLabel: "Numéro de clinicien",
    clinicianNumberDescription: "Il s'agit de votre numéro GMC ou HCPC",
    noClinicianNumber: "Aucun numéro de clinicien",
    myOrganisations: "Mes organisations",
    myTeam: "Équipe",
    teamPageDescription:
        "Toutes les personnes de vos organisations. Invitez des collègues et choisissez une personne de contact par défaut.",
    secretaryDefaultHelpTitle: "Personne de contact par défaut",
    secretaryDefaultHelp:
        "Votre personne de contact par défaut pour une organisation est préremplie comme contact lorsque vous invitez un patient. Le premier secrétaire que vous ajoutez devient la personne par défaut. Vous pouvez la modifier dans le tableau.",
    secretaryDefaultColumnHelp:
        "Utilisée comme personne de contact lorsque vous invitez des patients dans cette organisation.",
    filterRole: "Rôle",
    filterOrganisation: "Organisation",
    filterAddedBy: "Ajouté par",
    filterAllRoles: "Tous les rôles",
    filterAllOrganisations: "Toutes les organisations",
    filterAllAddedBy: "Tout le monde",
    filterInvitedByMe: "Invités par moi",
    filterNotInvitedByMe: "Non invités par moi",
    filterFavouritesOnly: "Favoris uniquement",
    filters: actionCopyFr.filters,
    filterTeamAria: "Filtrer l'équipe",
    teamFilterTitle: "Filtres",
    teamFilterDescription: "Filtrez cette liste par rôle, organisation et favoris.",
    selectRoles: "Sélectionner des rôles",
    selectOrganisations: "Sélectionner des organisations",
    columnsButton: actionCopyFr.columns,
    columnName: listCopyFr.name,
    columnRole: listCopyFr.role,
    columnOrganisation: listCopyFr.organisation,
    columnAddedBy: "Ajouté par",
    columnDefaultSecretary: "Personne de contact par défaut",
    columnFavourite: "Favori",
    invitedByYou: "Vous l'avez invité(e)",
    addUser: "Ajouter un utilisateur",
    membersShown: (count) => `${count} ${count === 1 ? "membre" : "membres"}`,
    defaultForOrganisation: (organisationName) => `Par défaut pour ${organisationName}`,
    setAsDefaultForOrganisation: (organisationName) => `Définir par défaut pour ${organisationName}`,
    viewAll: "Tout voir",
    teamLabel: "Équipe",
    staffCount: (count) => `${count} membres du personnel`,
    memberCount: (count) => `${count} ${count === 1 ? "membre" : "membres"}`,
    favouritesCount: (count) => `${count} ${count === 1 ? "favori" : "favoris"}`,
    moreTeamMembers: (count) => `+${count} autres membres de l'équipe`,
    noTeamMembersYet: "Aucun membre d'équipe pour le moment",
    searchTeamPlaceholder: "Rechercher...",
    searchTeamAria: "Rechercher des membres de l'équipe",
    closeSearch: "Fermer la recherche",
    openSearch: "Ouvrir la recherche",
    allStaff: "Tout le personnel",
    invitedTab: "Invités",
    favouritesTab: "Favoris",
    noTeamMembersFound: "Aucun membre d'équipe trouvé.",
    noFavouritesYet: "Aucun favori pour le moment.",
    noInvitesYet: "Vous n'avez encore invité aucun utilisateur.",
    inviteColleaguesToBuildTeam: "Invitez des collègues pour commencer à constituer votre équipe",
    manageTeam: "Gérer l'équipe",
    secretaryOrganisationsLabel: "Organisations du secrétaire",
    secretaryDefaultBadge: "Par défaut",
    setAsDefaultSecretary: "Définir par défaut",
    clearDefaultSecretary: "Retirer par défaut",
    addAsMySecretary: "Ajouter comme mon secrétaire",
    removeAsMySecretary: "Retirer",
    addSecretaryForOrganisation: "Ajouter un secrétaire",
    inviteNewSecretary: "Inviter un nouveau secrétaire",
    chooseExistingSecretary: "Choisir dans l'organisation",
    chooseExistingSecretaryTitle: "Choisir un secrétaire",
    noOtherSecretariesInOrganisation: "Aucun autre secrétaire trouvé dans cette organisation.",
    inviteUser: "Inviter un utilisateur",
    diaryUsageUsedLabel: "Utilisation",
    diaryUsageUnlimited: "Journaux illimités",
    diaryUsageAtCapHint:
        "Vous avez atteint votre limite de journaux pour cette période. Passez à une formule supérieure pour inviter davantage de patients.",
    changePassword: "Modifier le mot de passe",
    logout: "Se déconnecter",
    help: "Aide",
    menu: "Menu",
    close: actionCopyFr.close,
    contactSupportPrompt: "Un doute ou besoin d'aide ?",
    contactSupport: "Contacter l'assistance",
    incompleteTitle: "Profil incomplet",
    incompleteMessage:
        "Pour utiliser Patient Watch, veuillez d'abord compléter votre profil en renseignant tous les champs signalés comme manquants ci-dessous.",
    profileCompletionLabel: (progress) => `Profil complété à ${progress} %`,
    addNextMissingField: "Terminer votre profil",
    addMissingName: "Ajouter le nom",
    addMissingDateOfBirth: "Ajouter la date de naissance",
    addMissingEmail: "Ajouter l'adresse e-mail",
    addMissingPhone: "Ajouter le numéro de téléphone",
    addMissingOrganisation: "Ajouter une organisation",
    addMissingNotifications: "Ajouter les préférences de notification",
    navProfileDescription: "Mettez à jour les informations nécessaires au bon fonctionnement de Patient Watch.",
    navDiaryLabel: "Journal",
    navDiaryDescription: "Créez des journaux permettant aux patients de suivre leurs symptômes.",
    goToDiary: "Aller au journal",
    addDoneSeeProgress: "Ajoutez ce qui est fait et suivez votre progression",
    goToDiaries: "Aller aux journaux",
    seeResults: "Voir les résultats",
    seeDiaries: "Voir les journaux",
    onboarding: "Prise en main",
    onboardingNameTitle: "Quel est votre nom ?",
    onboardingNameDescription: "C'est ainsi que votre clinicien vous identifiera dans Patient Watch.",
    onboardingDateOfBirthTitle: "Quelle est votre date de naissance ?",
    onboardingDateOfBirthDescription: "Nous l'utilisons pour rapprocher votre dossier de santé en toute sécurité.",
    onboardingEmailTitle: "Quelle est votre adresse e-mail ?",
    onboardingEmailDescription:
        "Nous l'utiliserons uniquement pour votre compte Patient Watch et les messages liés à vos soins.",
    onboardingPhoneTitle: "Quel est votre numéro de téléphone ?",
    onboardingPhoneDescription: "Les rappels par SMS vous aident à remplir vos formulaires au bon moment.",
    onboardingNotificationsTitle: "Comment souhaitez-vous être relancé(e) ?",
    beginOnboarding: "Commencer la prise en main",
    onboardingSignedOutDescription: "Veuillez cliquer sur Continuer pour ajouter vos informations.",
    continue: actionCopyFr.continue,
    next: actionCopyFr.next,
    save: actionCopyFr.save,
    cancel: actionCopyFr.cancel,
    skip: actionCopyFr.skip,
    skipConfirmTitle: "Voulez-vous vraiment passer cette étape ?",
    skipEmailDescription:
        "L'adresse e-mail sert à envoyer des notifications importantes. Passer cette étape peut vous empêcher de recevoir des mises à jour en temps utile.",
    skipSmsDescription:
        "Le numéro de téléphone sert à envoyer des SMS de notification importants. Passer cette étape peut vous empêcher de recevoir des mises à jour en temps utile.",
    saving: actionCopyFr.saving,
    creating: "Création...",
    organisation: listCopyFr.organisation,
    organisationMissing: "Organisation manquante",
    addOrganisation: "Ajouter une organisation",
    joinOrganisation: "Rejoindre une organisation",
    organisationMissingDescription: "Veuillez rejoindre une organisation pour créer des journaux.",
    addOrganisationToContinue: "Veuillez ajouter une organisation pour continuer",
    informationMissing: "Informations manquantes",
    role: listCopyFr.role,
    openMenu: "Ouvrir le menu",
    showUsers: "Afficher les utilisateurs",
    showQrCode: "Afficher le code QR",
    organisationCode: "Code de l'organisation",
    organisationCodeDescriptionPrefix:
        "Pour rejoindre une organisation, utilisez le code qu'elle vous a communiqué. Si vous n'en avez pas,",
    requestCode: "demandez un code",
    delete: actionCopyFr.delete,
    deleting: actionCopyFr.deleting,
    rolePatient: "Patient",
    roleClinician: "Clinicien",
    roleSecretary: "Secrétaire",
    roleAdmin: "Administrateur",
    roleManager: "Gestionnaire",
    roleValidator: "Validateur",
    organisationDescription: "Il s'agit du nom de votre clinique, cabinet ou hôpital.",
    profileOrganisationDescription:
        "L'ajout d'une organisation permettra le partage de données entre vous et cette organisation.",
    yourOrganisation: "Votre organisation",
    professional: "Professionnel",
    medicalSpecialty: "Spécialité médicale",
    selectSpecialty: "Sélectionner une spécialité",
    specialtyDescription: "Nous créerons des modèles spécifiques à votre spécialité",
    professionalRegistrationNumber: "Numéro d'enregistrement professionnel (facultatif)",
    professionalRegistrationPlaceholder: "GMC, HCPC ou autre numéro d'enregistrement",
    professionalRegistrationDescription:
        "Votre numéro GMC, HCPC ou d'enregistrement auprès de votre ordre professionnel",
    welcomeTitle: "Bienvenue sur Patient Watch !",
    welcomePatientDescription:
        "Aidez à améliorer les traitements et la recherche en suivant votre parcours de rétablissement !",
    welcomeClinicianDescription:
        "Offrez à vos patients des soins personnalisés, économisez des consultations et recueillez des informations précieuses sur vos traitements.",
    welcomeSecretaryDescription:
        "Gérez les dossiers des patients et coordonnez efficacement les soins au sein de votre équipe.",
    welcomeManagerDescription: "Suivez la manière dont les données sont recueillies dans votre organisation.",
    settingUpAccount: "Configuration de votre compte...",
    gettingAccountReady: "Nous préparons tout pour vous",
    continueToProfileSetup: "Continuer vers la configuration du profil",
    processingNewUser: "Traitement du nouvel utilisateur",
    onboardingComplete: "Prise en main terminée",
    authenticationError: "Erreur d'authentification",
    setupMoment: "Un instant, nous configurons tout...",
    settingUpDiary: "Configuration de votre journal...",
    almostThere: "Presque terminé !",
    patientSetupCompleteDescription:
        "Merci d'avoir terminé la configuration. Ajoutez vos saisies de journal au fur et à mesure, et vous pourrez ensuite voir vos scores sur le graphique de progression.",
    setupCompleteDescription: "Vous pouvez maintenant utiliser Patient Watch pour partager votre progression !",
    supportMessage: "Veuillez envoyer un message à support@patient-watch.com",
    retry: actionCopyFr.retry,
    edit: actionCopyFr.edit,
    current: "Actuel",
    change: "Modifier",
    deleteAccount: "Supprimer le compte",
    deleteAccountConfirmTitle: "Êtes-vous absolument sûr(e) ?",
    deleteAccountConfirmDescription:
        'Cette action est irréversible. Pour confirmer que vous souhaitez supprimer votre compte, veuillez saisir "delete my account" ci-dessous.',
    deleteAccountPageDescription: "Supprimez définitivement votre compte et toutes les données associées",
    deleteAccountReason: "Motif de la suppression du compte",
    deleteAccountSubmit: "Supprimer le compte",
    submitting: actionCopyFr.submitting,
    deleteAccountConfirmationLabel: "Confirmation",
    deleteAccountPlaceholder: 'Saisissez "delete my account"',
    deletingAccount: "Suppression...",
    warningNotificationsDisabled: "Attention : notifications désactivées",
    editPreferences: "Modifier les préférences",
    remindersDescription: "Les rappels sont essentiels pour que Patient Watch améliore votre santé.",
    receiveEmailReminders: "Recevoir des rappels par e-mail.",
    receiveSmsReminders: "Recevoir des rappels par SMS.",
    pushNotificationSettingsError:
        "Pour activer les notifications push, vous devez activer les notifications dans les paramètres de votre application.",
    actionRequired: (count) => `Action requise (${count})`,
    actionRequiredForms: (count) => `Action requise (${count} formulaire${count === 1 ? "" : "s"})`,
    diaryCardDescription:
        "Les journaux sont vos suivis de santé personnels et aident à améliorer les traitements et la recherche.",
    formDue: (count) => `Vous avez ${count} formulaire${count === 1 ? "" : "s"} à remplir.`,
    diariesNeedAttention: (count) =>
        `Vous avez ${count} ${count === 1 ? "journal" : "journaux"} dont les formulaires nécessitent votre attention.`,
    welcomeModalTitle: (name: string) => `Bienvenue, ${name} !`,
    welcomeDescription: "Votre compte est entièrement configuré et vos modèles de spécialité sont prêts à l'emploi.",
    welcomeTestPatientTitle: "Essayez avec un patient test",
    welcomeTestPatientDescription:
        "Pour voir comment vos patients vivront Patient Watch, invitez un utilisateur test avec une autre adresse e-mail.",
    welcomeAddFirstPatient: "Ajouter mon premier patient",
    welcomeDoctorFallback: "Docteur",
    closeBanner: "Fermer la bannière",
    home: "Accueil",
    currentPlan: "Formule actuelle",
    currentPlanDescription: "Votre abonnement et votre quota de journaux",
    noActiveSubscription: "Vous n'avez pas d'abonnement actif",
    billingStatus: "Statut",
    nextBillingDate: "Prochaine date de facturation",
    accessUntil: "Accès jusqu'au",
    planDetails: "Détails de la formule",
    trialPlanDetails: "5 nouveaux journaux par période de facturation",
    enterprisePlanDetails: "Journaux illimités",
    choosePlanToStart: "Choisissez une formule pour commencer avec Patient Watch",
    upgradeYourPlan: "Passer à une formule supérieure",
    changeYourPlan: "Changer de formule",
    availablePlans: "Formules disponibles",
    upgradePlanDescription: "Passez de la formule gratuite à Starter ou Pro pour un quota de journaux plus élevé",
    changePlanDescription: "Comparez les formules et modifiez votre abonnement",
    choosePlanDescription: "Choisissez la formule qui correspond le mieux à vos besoins",
    preferStartFree: "Vous préférez commencer gratuitement ?",
    createFreeAccount: "Créer un compte gratuit",
    needMore: "Besoin de plus ? Découvrez notre",
    enterprisePlan: "formule Enterprise",
    cancelSubscription: "Résilier l'abonnement",
    managePaymentMethod: "Gérer le moyen de paiement",
    undoCancellationHint:
        "Vous souhaitez conserver votre formule ? Utilisez « Gérer le moyen de paiement » pour rouvrir Stripe et annuler la résiliation.",
    paymentRequired: "Paiement requis",
    paymentOverdue:
        "Votre paiement est en retard. Veuillez mettre à jour votre moyen de paiement pour continuer à utiliser Patient Watch.",
    subscriptionCanceling: "Résiliation de l'abonnement en cours",
    subscriptionCancelingOn: (date) =>
        `Votre abonnement sera résilié le ${date}. Vous conserverez l'accès jusqu'à cette date.`,
    subscriptionCancelingPeriod:
        "Votre abonnement sera résilié à la fin de la période de facturation. Vous conserverez l'accès jusqu'à cette date.",
    subscriptionCancelled: "Abonnement résilié",
    subscriptionCancelledDescription:
        "Votre abonnement payant est terminé. Choisissez une formule ci-dessous pour reprendre la facturation.",
    unableToCancel: "Impossible de résilier",
    unableToChangePlan: "Impossible de changer de formule",
    unableToOpenBillingPortal: "Impossible d'ouvrir le portail de facturation",
    unableToStartCheckout: "Impossible de lancer le paiement",
    failedToLoadBilling: "Échec du chargement des informations de facturation. Veuillez réessayer plus tard.",
    billingStatusCanceling: "RÉSILIATION EN COURS",
    billingStatusUnknown: "INCONNU",
    pleaseTryAgain: "Veuillez réessayer.",
    planStarter: "Starter",
    planPro: "Pro",
    perMonth: "/mois",
    currentPlanBadge: "Actuelle",
    popularBadge: "Populaire",
    starterDiaries: "20 nouveaux journaux/mois",
    proDiaries: "50 nouveaux journaux/mois",
    emailSmsReminders: "Rappels par e-mail et SMS",
    emailSupport: "Assistance par e-mail",
    prioritySupport: "Assistance prioritaire",
    currentPlanButton: "Formule actuelle",
    subscribeToStarter: "Souscrire à Starter",
    subscribeToPro: "Souscrire à Pro",
    downgradeToStarter: "Passer à Starter",
    upgradeToPro: "Passer à Pro",
    includedInEnterprise: "Inclus dans Enterprise",
};
